// extracted by mini-css-extract-plugin
export default {"container":"FowardButton_container__zW1+C","link":"FowardButton_link__md2oL"};